module.exports = __webpack_public_path__ + "static/media/b1_p13_narration.5aace511.mp3";